// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"182":"b49acf5a","765":"eeb6babc"}[chunkId] + ".chunk.css";
};